<template>
  <div class="log">
    <Form :label-width="69" inline>
      <FormItem label="日志级别">
        <Select v-model="params.type" :label-in-value="true" style="width: 200px;">
          <Option
            v-for="(item, index) in levelList"
            :value="item.type"
            :key="index"
          >{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem label="时间范围">
        <DatePicker type="daterange" v-model="rangeDate" :start-date="new Date()" placement="bottom-end" placeholder="请选择时间范围" style="width: 200px" />
      </FormItem>
      <Button type="primary" style="margin: 0 12px 0 0;" @click="search()">查询</Button>
      <Button @click="reset()">重置</Button>
    </Form>
    <div>
      <div class="title"><div class="line"></div>日志内容</div>
      <Table border highlight-row :columns="columns" :data="dataList" :height="400"></Table>
      <div style="display: flex;justify-content: flex-end;margin-top: 16px;">
        <Page
          :total="total"
          :page-size-opts="params.sizes"
          :current="params.i"
          :page-size="params.pageSize"
          show-total
          @on-change="pageChange"
        />
         <!-- <Page :total="100"></Page> -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default{
  props:{
    from:{
      default:'',
      type: String
    }
  },
  data(){
    return{
      rangeDate:[],
      params:{
        startTime:'',
        endTime:'',
        type:'',
        n:'',
        pageSize:10,
        i:1
      },
      levelList:[
        {
          name:'跟踪',
          type:'Trace'
        },
        {
          name:'调试',
          type:'Debug'
        },
        {
          name:'信息',
          type:'Information'
        },
        {
          name:'警告',
          type:'Warning'
        },
        {
          name:'错误',
          type:'Error'
        },
        {
          name:'严重',
          type:'Critical'
        }
      ],
      columns:[
        { title: "日志级别", key: "logLevel",width:100 },
        { title: "时间", key: "createTime",width:180 },
        { title: "内容", key: "context" },
      ],
      total:0,
      dataList:[]
    }
  },
  methods:{
    //分页
    pageChange: function (page) {
      this.params.i = page
      this.getData()
    },
    search(){
      this.params.startTime =  this.rangeDate[0]?moment(this.rangeDate[0]).format('YYYY-MM-DD')+' 00:00:00' : ''
      this.params.endTime = this.rangeDate[1]?moment(this.rangeDate[1]).format('YYYY-MM-DD')+' 23:59:59' : ''
      this.getData()
    },
    reset(){
      this.params.pageSize=10
      this.params.i=1
      this.params.type=''
      this.params.startTime=''
      this.params.endTime=''
      this.rangeDate=[]
    },
    getData(){
      this.$api.get(`ServiceInfo/serviceLog`,this.params).then((res) => {
        this.dataList = res.data
        this.total = res.dataCount
      });
    }
  },
  mounted(){
    if(this.from=='scp'){
      this.params.n = 'ProcessCenterSCP'
    }else if(this.from=='scu'){
      this.params.n = 'ProcessCenterSCU'
    }else if(this.from=='dicom'){
      this.params.n = 'ProcessCenterQR'
    }else if(this.from=='imgMake'){
      this.params.n = 'ProcessImageArchive'
    }else if(this.from=='worklist'){
      this.params.n = 'ProcessWorkList'
    }else if(this.from=='qa'){
      this.params.n = 'ProcessSendImageToRIS'
    }else if(this.from=='clear'){
      this.params.n = 'ProcessCenterDataClean'
    }
    else{
      this.params.n = 'ProcessCenterOOSUpload'
    }
    this.getData() 
  }
}
</script>
<style scoped lang="scss">
.log{
  .line{
    width: 4px;
    height: 18px;
    background: #338BFF;
    margin: 3px 8px 0 0;
  }
  .title{
    display: flex;
    margin: 0 0 12px 0;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }
}
</style>